import React, { useEffect, useRef, useState } from 'react';
import {
  BATTLE_BG_NATIVE_WIDTH,
  BATTLE_BG_NATIVE_HEIGHT,
  BATTLE_BG_SCROLL_DURATION_MS,
  BATTLE_BG_REWIND_DURATION_MS,
} from '../constants/battleArenaConfig';

const normalizeImageUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/')) return url;
  return `/${url}`;
};

const BattleArenaBackground = ({
  imageUrl,
  offsetPx = 0,
  rewinding = false,
  onMaxOffsetChange,
}) => {
  const wrapRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      setContainerWidth(entry.contentRect.width);
      setContainerHeight(entry.contentRect.height);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const src = normalizeImageUrl(imageUrl);
  const imageDisplayWidth =
    containerHeight > 0
      ? (BATTLE_BG_NATIVE_WIDTH / BATTLE_BG_NATIVE_HEIGHT) * containerHeight
      : BATTLE_BG_NATIVE_WIDTH;
  const maxOffset = Math.max(0, imageDisplayWidth - containerWidth);
  const clampedOffset = Math.min(Math.max(0, offsetPx), maxOffset);

  useEffect(() => {
    if (onMaxOffsetChange) onMaxOffsetChange(maxOffset);
  }, [maxOffset, onMaxOffsetChange]);

  if (!src) return null;

  const scrollMs = rewinding ? BATTLE_BG_REWIND_DURATION_MS : BATTLE_BG_SCROLL_DURATION_MS;

  return (
    <div
      ref={wrapRef}
      className="battle-arena-background-wrap"
      style={{ '--battle-bg-scroll-ms': `${scrollMs}ms` }}
    >
      <img
        src={src}
        alt=""
        className="battle-arena-background-img"
        draggable={false}
        style={{ transform: `translateX(-${clampedOffset}px)` }}
      />
    </div>
  );
};

export default React.memo(BattleArenaBackground);
